import {} from "@knyt/artisan";
import { BaseConsumer } from "./BaseConsumer.js";
import { BaseProvider } from "./BaseProvider.js";
import { ContextRequestEvent } from "./events.js";
/**
 * @remarks
 *
 * This controller should be added before the host is connected.
 */
export function createContext(initialValue, description) {
    /**
     * A unique key used to identify the context.
     */
    const contextKey = Symbol(description);
    function isRelevantContextRequest(event) {
        return (event instanceof ContextRequestEvent && event.contextKey === contextKey);
    }
    class Consumer extends BaseConsumer {
        constructor(host, { onUpdate, target, }) {
            super(host, { initialValue, onUpdate, target });
        }
        /** @internal scope: package */
        get _contextKey() {
            return contextKey;
        }
    }
    class Provider extends BaseProvider {
        constructor(host, { target, }) {
            super(host, { initialValue, target });
        }
        /** @internal scope: package */
        get _contextKey() {
            return contextKey;
        }
        /** @internal scope: package */
        _isRelevantContextRequest(event) {
            return isRelevantContextRequest(event);
        }
    }
    function createConsumer(host) {
        return new Consumer(host, { target: host });
    }
    function createProvider(host) {
        return new Provider(host, { target: host });
    }
    return {
        Consumer,
        createConsumer,
        createProvider,
        initialValue,
        Provider,
    };
}
